/// <reference path="./MultiText.ts" />
namespace HA.Core.HTML.Editor {
    export class MultiMedia extends MultiText {
        /**
         * @returns {Array}
         */
        public getSelections() {
            const data = [];
            this.getItems().forEach((s: SelectorItem) => {
                if (s.isChecked()) {
                    data.push(s.getValue());
                }
            });

            return data;
        }

        /**
         * @returns {Map}
         */
        protected getItems() {
            return this.getList().getItems();
        }

        /**
         *
         * @returns {List}
         */
        protected getList() {
            return this.get("list");
        }

        protected addImageFiles(files: File[]) {
            for (const file of files) {
                this.addImageFile(file);
            }
            if (this.has("pfunc") && this.has("max") && files.length >= this.get("max")) {
                this.get("pfunc").itemClick(this.getSelections());
            }
        }

        protected addImageFile(file: any) {
            if (file && !this.getList().hasValue(file.name)) {
                const imgContainer = new MediaContainer(toMap({f: file}));
                const div = new Div({className: "thumb"});
                div.appendChild(new Img(toMap({f: file})));
                imgContainer.appendChild(div);
                this.getList().addItem(new ImageItem(toMap({item: imgContainer, s: true})));
            }
        }

        /**
         *
         * @param data
         * @returns {HA.Core.HTML.SelectorItem}
         */
        protected createItem(data: any) {
            return new TextItem(data);
        }

        /**
         *
         * @param data
         * @returns {HA.Core.HTML.MultiTextHead}
         */
        protected createHead(data?: any) {
            const me = this;
            return new MultiTextHead(toMap({
                accept : me.get("encodings") || "image/x-png,image/gif,image/jpeg,image/svg+xml",
                ed: {
                    addImageFile: (file: File) => {
                        if (file) {
                            me.addImageFile(file);
                        }
                    },
                    addImageFiles: (files?: File[]) => {
                        if (files) {
                            me.addImageFiles(files);
                        }
                    },
                },
                max: me.get("max"),
                t: me.get("t") || "img/url",
                tc: me.get("tc"),
            }));
        }
    }
}
